<template>
  <div class="comment">
    <h1>
      全部评论<span class="comm-num">({{ commentList.length }})</span>
    </h1>
    <div class="btns">
      <el-checkbox class="checkbox" v-model="isCheckedAll" @change="checkAll"
        >全选</el-checkbox
      ><el-button class="ml-20" @click="deleteAll(2)">举报</el-button
      ><el-button @click="deleteAll(1)">删除</el-button>
    </div>

    <div class="comm-cont" v-for="(item, index) in commentList" :key="index">
      <!-- 一级评论 -->
      <div v-if="item.parent_id === 0">
        <div class="avatar">
          <div class="ava-check">
            <el-checkbox
              v-model="item.checked"
              :true-label="item.id"
            ></el-checkbox>
          </div>
          <el-avatar
            :size="sizeList[1]"
            :src="getUserPhoto(item.photourl)"
          ></el-avatar>
        </div>
        <div class="comm-detail">
          <span class="name">{{ item.displayname }}</span>
          <!-- <a href="/">查看评论</a> -->
          <div class="cont">{{ item.cont }}</div>
          <div class="date">
            {{ dateFormat(item.create_date)
            }}<a href="##" v-on:click="repleyShow($event)">回复</a>
            <a href="javascript:;" @click="report(item.id)">举报</a>
            <a href="javascript:;" @click="deleteComment(item.id)">删除</a>
          </div>
          <div class="replyarea">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              :rows="4"
              v-model="rplcont"
              maxlength="120"
              show-word-limit
            >
            </el-input>
            <div class="replybtns">
              <el-button
                type="primary"
                @click="
                  reply(
                    item.id,
                    item.cont_id,
                    item.uid,
                    item.displayname,
                    $event
                  )
                "
                plain
                >发表回复</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <!-- 二级评论 -->
      <div v-if="item.parent_id > 0">
        <div class="avatar">
          <div class="ava-check">
            <el-checkbox
              v-model="item.checked"
              :true-label="item.id"
            ></el-checkbox>
          </div>
          <el-avatar :size="sizeList[1]" :src="getUserPhoto(item.photourl)"></el-avatar>
        </div>
        <div class="comm-detail">
          <span class="name">{{ item.displayname }}</span> 回复
          <span class="name"> @{{ item.replied_name }}</span>
          <div class="cont">{{ item.cont }}</div>
          <div class="date">
            {{ dateFormat(item.create_date)
            }}<a href="##" v-on:click="repleyShow($event)">回复</a>
            <a href="javascript:;" @click="report(item.id)">举报</a>
            <a href="javascript:;" @click="deleteComment(item.id)">删除</a>
          </div>
          <div class="replyarea">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              :rows="4"
              maxlength="120"
              v-model="rplcont"
              show-word-limit
            >
            </el-input>
            <div class="replybtns">
              <el-button
                type="primary"
                @click="
                  reply(
                    item.id,
                    item.cont_id,
                    item.uid,
                    item.displayname,
                    $event
                  )
                "
                plain
                >发表回复</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
  </div>
</template>

<style scoped>
.el-checkbox-group {
  font-size: 16px;
}
.comment {
  background-color: #ffffff;
  text-align: left;
  padding: 16px 32px;
}
.comm-cont {
  border-bottom: #e2e2e2 1px solid;
  margin-top: 32px;
  position: relative;
  padding-bottom: 32px;
}
.avatar {
  display: inline-block;
  position: absolute;
  left: 0;
}
.avatar {
  vertical-align: middle;
  padding-top: 8px;
}
.comm-detail {
  margin-left: 90px;
  padding-top: 6px;
}
.date,
.date a {
  color: #999;
  font-size: 14px;
}
.date a {
  margin-left: 16px;
}
.name {
  color: #757575;
  font-size: 14px;
}
.mr-10 {
  margin-right: 10px;
}
.ml-20 {
  margin-left: 20px;
}
.cont {
  padding: 16px 0 16px 0;
}
.comm-num {
  color: #999;
  font-size: 14px;
  font-weight: normal;
}
.see-comm {
  color: #00a1d6;
  margin-left: 16px;
  font-size: 14px;
}
a:hover {
  color: #00a1d6;
}
.ava-check {
  float: left;
  padding: 8px;
  padding-right: 16px;
}
.replyarea {
  max-width: 800px;
  margin-top: 8px;
  display: none;
}
.replybtns {
  text-align: right;
  margin-top: 8px;
}
</style>

<script>
export default {
  name: "Comment",
  mounted() {
    this.getCommentList();
  },
  data() {
    return {
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      squareUrl:
        "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      sizeList: ["large", "medium", "small"],
      commentList: [],
      rplcont: "",
      isCheckedAll: false,
      checkArr: [], //选中数组
      CheckedAllArr: [], //全选数组
    };
  },
  computed: {
    // x选中的id this.checkedArr获取到
    checkedArr() {
      return this.commentList
        .filter((item) => item.checked === true)
        .map((item) => item.id);
    },
  },
  methods: {
    getUserPhoto(userphoto) {
      if (userphoto != null && userphoto != "") {
        if (this.GLOBAL.isOnLine) {
          return this.GLOBAL.baseURL + userphoto;
        } else {
          return this.GLOBAL.localBaseURL + userphoto;
        }
      }
      return this.circleUrl;
    },
    dateFormat(date) {
      return date.replace("T", " ").split(".")[0];
    },
    reply(pid, contid, uid, displayname, e) {
      if (this.loginuid == 0) {
        //未登录
        this.$alert("请先登录", "", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (this.rplcont == "") {
        this.$alert("请填写内容", "", {
          confirmButtonText: "确定",
        });
      }
      var cont = this.rplcont;
      var e2 = e.currentTarget.parentNode.parentNode;
      this.$http
        .post("/api/PlayerDetailComment/", {
          cont: cont,
          parent_id: parseInt(pid),
          cont_id: contid,
          replied_uid: uid,
          replied_name: displayname,
        })
        .then((r) => {
          this.rplcont = "";
          console.log(r);
          //获取角色列表
          if (r.data.code == 200) {
            for (var i = 0; i < this.commentList.length; i++) {
              if (this.commentList[i].id == pid) {
                var newComm = {
                  id: r.data.msg,
                  parent_id: pid,
                  cont: cont,
                  cont_id: contid,
                  displayname: localStorage.getItem("name"), //回复人姓名
                  replied_name: displayname, //被回复人姓名
                  create_date: this.commentList[i].create_date,
                };
                this.commentList.splice(i + 1, 0, newComm);
                break;
              }
            }
            e2.style.display = "none";
            this.$alert("评论成功", "", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("评论失败，请重试", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          this.rplcont = "";
          console.log(e);
        });
    },
    repleyShow: function (e) {
      var cur = e.currentTarget;
      var displayArea = cur.parentNode.nextSibling;
      var disstate = displayArea.style.display;
      if (disstate === "" || disstate === "none") {
        displayArea.style.display = "block";
      } else {
        displayArea.style.display = "none";
      }
    },
    getCommentList() {
      this.$http
        .get("/api/comment")
        .then((r) => {
          if (r.data != null && r.data != "") {
            this.commentList = r.data.map((d) => {
              return {
                ...d,
                checked: false,
              };
            });
            // this.setCheckedAllArr();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    report(id) {
      if (!confirm("确认要举报吗？")) return;
      this.$http
        .post("/api/commentt/", {
          ids: id + ",",
          type: 2,
        })
        .then((r) => {
          if (r.data == "ok") {
            this.$alert("举报成功", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    deleteComment(id) {
      if (!confirm("确定要删除吗？")) return;
      this.$http
        .post("/api/commentt/", {
          ids: id + ",",
          type: 1,
        })
        .then((r) => {
          if (r.data == "ok") {
            this.$alert("删除成功", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    deleteAll(type) {
      //全部举报或者删除
      var tips = type == 1 ? "确定要删除吗？" : "确定要举报吗？";
      if (!confirm(tips)) return;
      //var _ids = this.checkArr.join();
      var _ids = this.checkedArr.join();
      if (_ids == "") return;
      this.$http
        .post("/api/commentt/", {
          ids: _ids,
          type: type,
        })
        .then((r) => {
          if (r.data == "ok") {
            this.$alert("删除成功", "", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("删除失败,请重试", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    checkAll() {
      /* if (!this.isCheckedAll) {
        //实现反选
        this.checkArr = [];
      } else {
        //实现全选
        this.checkArr = [];
        var _this = this;
        this.CheckedAllArr.forEach(function (id) {
          _this.checkArr.push(id);
        });
      } */
      this.commentList.forEach((item) => {
        this.$set(item, "checked", this.isCheckedAll);
      });
    },
    // watch: {
    //   //深度 watcher
    //   'checkArr': {
    //     handler: function (val) {
    //       if (val.length === this.CheckedAllArr.length) {
    //         this.isCheckedAll = true;
    //       } else {
    //         this.isCheckedAll = false;
    //       }
    //     },
    //     deep: true,
    //   },
    // },
    /* setCheckedAllArr() {
      this.commentList.forEach((item) => {
        this.CheckedAllArr.push(item.id);
      });
    }, */
  },
};
</script>
